import React from "react";
import { FiArrowRight, FiClock, FiUsers } from "react-icons/fi";
import Button from "../common/Button";

const EditorialFeature = ({ recipe }) => (
  <section className="section editorial-feature">
    <div className="site-container editorial-feature__grid">
      <div className="editorial-feature__image-wrap">
        <img src={recipe.image} alt={recipe.title} loading="lazy" />
        <span className="editorial-feature__stamp" aria-hidden="true">
          Cook<br />something<br />vivid
        </span>
      </div>
      <div className="editorial-feature__content">
        <p className="eyebrow">From the recipe archive</p>
        <h2>{recipe.title}</h2>
        <p>{recipe.excerpt}</p>
        <div className="recipe-meta-inline">
          <span><FiClock aria-hidden="true" /> {recipe.totalTime} minutes</span>
          <span><FiUsers aria-hidden="true" /> Serves {recipe.servings}</span>
        </div>
        <Button to={`/recipes/${recipe.slug}`}>
          Cook this recipe <FiArrowRight aria-hidden="true" />
        </Button>
      </div>
    </div>
  </section>
);

export default EditorialFeature;
